var reservation = {
  options: {
    // global options
  },

  selectors: {
    reservation_form_head: ".js-reservation-form-head",
    reservation_form_content: ".js-reservation-form-content",
    input_hidden: ".js-reservation-form-head-input-hidden",
  },

  init: function () {
    const self = this;

    self.loadFunctionInside();
  },

  loadFunctionInside: function () {
    const self = this;

    jQuery(self.selectors.reservation_form_head + " a").on("click", function (event) {
      event.preventDefault();
      const id_target = jQuery(this).data("target-id");

      jQuery(self.selectors.input_hidden).val(id_target); //set hidden input value

      jQuery(self.selectors.reservation_form_head + " a").removeClass("active");
      jQuery(this).addClass("active");

      //JS transition API
      if (document.startViewTransition) {
        document.startViewTransition(() => {
          jQuery(self.selectors.reservation_form_content).removeClass("show"); //hide all
          jQuery(self.selectors.reservation_form_content + "[data-id='" + id_target + "']").addClass("show");
        });
      } else {
        jQuery(self.selectors.reservation_form_content).removeClass("show"); //hide all
        jQuery(self.selectors.reservation_form_content + "[data-id='" + id_target + "']").addClass("show");
      }
    })
  }
}

// Export
export { reservation };